import { render, staticRenderFns } from "./RecodingTicket.vue?vue&type=template&id=36cde4c2&scoped=true&"
import script from "./RecodingTicket.vue?vue&type=script&lang=js&"
export * from "./RecodingTicket.vue?vue&type=script&lang=js&"
import style0 from "./RecodingTicket.vue?vue&type=style&index=0&id=36cde4c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36cde4c2",
  null
  
)

export default component.exports